import $ from 'jquery';

$('.js-chat-button').on('click', function(e){
    e.preventDefault();
    widgetClient.setWidgetVisiblity(true);
})

function checkWidgetOpen() {
    if (typeof widgetClient !== 'undefined' && widgetClient.clientContainer?.state?.hasWidgetbeenOpened) {
        onWidgetClientInitiated();

    } else {
        setTimeout(checkWidgetOpen, 500);
    }
}

checkWidgetOpen();

function onWidgetClientInitiated() {
    dataLayer.push({
        event_name: "contact",
        event_label: "chatbot",
        event: "fireEvent"
    });
}

